<template>
    <el-cascader
            class="region-picker"
            v-model="iValue"
            :options="options"
            @change="handleChange"></el-cascader>
</template>

<script>
import regionTree from './region.tree.element-ui.json'

export default {
    name: 'RegionPicker',
    props: {
        value: {
            default: null
        }
    },
    data() {
        return {
            options: regionTree,
            iValue: this.value
        }
    },
    watch: {
        value(nv) {
            this.iValue = nv
        }
    },
    methods: {
        handleChange(e) {
            this.$emit('input', e)
        }
    }
}
</script>

<style scoped lang="scss">
    .region-picker {
        width: 100%;
    }
</style>
